import ApiFetcher from "../utils/ApiFetcher";
import { put, call } from "redux-saga/effects";
import { makeQueryString } from "../utils/urls";
import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaSearchSuccess,
  sagaCreateSuccess,
  sagaUpdateSuccess
} from "../actions/ActionTypes";
import { showSuccessMsg, showErrorMsg } from "../actions";

const NOTICE_CATEGORIES = "NOTICE_CATEGORIES";
const NOTICE_CATEGORY = "NOTICE_CATEGORY";
const apiFetcher = new ApiFetcher();
export function* fetchNoticeCategories(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(
      apiFetcher.findAll,
      `notice_categories?${queryString}`
    );
    yield put({
      type: sagaListSuccess(NOTICE_CATEGORIES),
      data: res.data
    });
  } catch (e) {}
}

export function* searchNoticeCategories(action) {
  let queryString = makeQueryString(action.data);
  try {
    const res = yield call(
      apiFetcher.findAll,
      `notice_categories?${queryString}`
    );
    yield put({
      type: sagaSearchSuccess(NOTICE_CATEGORIES),
      data: res.data
    });
  } catch (e) {}
}

export function* fetchNoticeCategory(action) {
  try {
    const res = yield call(apiFetcher.find, "notice_categories", action.id);
    yield put({
      type: sagaOneSuccess(NOTICE_CATEGORY),
      data: res.data
    });
  } catch (e) {}
}

export function* createNoticeCategory(action) {
  try {
    const res = yield call(apiFetcher.create, "notice_categories", action.data);

    yield put({
      type: sagaCreateSuccess(NOTICE_CATEGORY),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("NoticeCategory created successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}

export function* updateNoticeCategory(action) {
  //restore old data to form when save fails -> probably in reducer
  try {
    const res = yield call(
      apiFetcher.update,
      "notice_categories",
      action.data,
      action.id
    );
    yield put({
      type: sagaUpdateSuccess(NOTICE_CATEGORY),
      data: res.data
    });
    if (res.data.success) {
      yield put(showSuccessMsg("NoticeCategory details updated successfully"));
    } else {
      yield put(
        showErrorMsg(
          "Sorry, errors were encountered whilst trying to save the data."
        )
      );
    }
  } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/sagas/notice_categories.js